/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, DatePicker, Loader, Text, ContainerControlSite, Content, Title, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';
import LogTable from './LogTable';
import { getChangelog } from '../../../actions/admin';
import * as dates from '@simplybenefits/sb-dates';

class Changelog extends Component {
    state = {
        dateRange: {
            startDate: new Date(Number(moment().startOf('day'))),
            endDate: new Date(Number(moment().endOf('day')))
        },
        displayDate: null,
        isDatePickerOpen: false
    };

    async componentDidMount() {
        await this.props.dispatch(getChangelog(this.state.dateRange.startDate, this.state.dateRange.endDate));

        this.setState({
            displayDate: this._getDisplayDate()
        });
    }

    _getDisplayDate = () => {
        const displayDateStart = this.state.dateRange.startDate._d ? dates.getUTC(this.state.dateRange.startDate._d, "ll", i18n.locale) : dates.getUTC(this.state.dateRange.startDate, "ll", i18n.locale);
        const displayDateEnd = this.state.dateRange.endDate._d ? dates.getUTC(this.state.dateRange.endDate._d, "ll", i18n.locale) : dates.getUTC(this.state.dateRange.endDate, "ll", i18n.locale);

        let dateDisplay = displayDateStart;

        if (displayDateStart !== displayDateEnd) {
            dateDisplay = i18n.t(tokens.labels.admin.dateRangeStartEnd, { dateStart: displayDateStart, dateEnd: displayDateEnd });
        }

        return dateDisplay;
    };

    _submitDate = async () => {

        if (this.state.dateRange.error) {
            return null;
        }

        await this.props.dispatch(getChangelog(this.state.dateRange.startDate, this.state.dateRange.endDate));

        this.setState({
            displayDate: this._getDisplayDate()
        });
    };

    /**
     * Used in the datepicker to set local state
     * @param startDate
     * @param endDate
     */
    _changeDate = (dateRange) => {
        this.setState({
            dateRange
        });
    };

    render() {
        const { whitelabel } = this.props;
        const styles = {
            contentBlock: {
                backgroundColor: Theme.colors.surface,
                boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
                display: 'block',
                margin: 'auto auto 30px auto',
                padding: '30px',
                position: 'relative',
                zIndex: Theme.zIndex.container
            },
            input: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: "15px"
            }
        };

        if (!this.state.displayDate) {
            return <Loader whitelabel={ whitelabel } />;
        }

        return (
            <ContainerControlSite>
                <Content>
                    <Title title={ i18n.t(tokens.titles.changeLog) } />

                    <div style={styles.input}>
                        <DatePicker
                            startDate={this.state.dateRange.startDate}
                            endDate={this.state.dateRange.endDate}
                            submitDate={this._changeDate}
                            includeToday={ true }
                            defaultSelectedValue={"Today"}
                            customStyle={{ backgroundColor: Theme.colors.backgroundGrey }}
                        />

                        <Button
                            color="primary"
                            customStyle={{
                                height: 55,
                                width: 180,
                                textTransform: "capitalize",
                                fontSize: 16,
                                marginLeft: "10px",
                                marginBottom: "8px"
                            }}
                            onClick={ this._submitDate }
                        >
                            { i18n.t(tokens.buttons.submit) }
                        </Button>
                    </div>

                    <div style={ styles.contentBlock }>
                        <Text
                            medium
                            display="inline-block"
                            marginBottom={20}
                        >
                            { i18n.t(tokens.labels.admin.showingChangesFrom, { displayDate: this.state.displayDate }) }
                        </Text>

                        {
                            this.props.changelog.length === 0 ?
                                <Text large>
                                    { i18n.t(tokens.labels.admin.noRecords) }
                                </Text>
                                :
                                <LogTable records={ this.props.changelog } />
                        }
                    </div>
                </Content>

                {this.props.loading && <Loader whitelabel={ whitelabel } noGif />}

                <span id="employee" />
            </ContainerControlSite>
        );
    }
}

Changelog.propTypes = {
    loading: PropTypes.bool,
    whitelabel: PropTypes.object
};

/**
 * @param state
 * @returns {{loading: boolean}}
 */
const mapStateToProps = (state) => ({
    loading: state.admin.loading,
    changelog: state.admin.changelog,
    whitelabel: state.whitelabel
});

export default (connect(mapStateToProps)(Changelog));